/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const resetCampaignPipelineConfigDataSchema = z.object({
	migrations: z.record(z.string(), z.string()).nullable().optional(),
})

export type ResetCampaignPipelineConfigDataSchema = z.infer<typeof resetCampaignPipelineConfigDataSchema>
